const licenses = [
  {
    name: 'Icons',
    type: 'Icons',
    year: ''
  },

  {
    name: '@mui/material',
    year: 'Copyright (c) 2014 Call-Em-All',
    type: 'MIT'
  },
  {
    name: '@mui/icons-material',
    year: 'Copyright (c) 2014 Call-Em-All',
    type: 'MIT'
  },
  {
    name: '@redux-beacon/google-tag-manager',
    year: 'Copyright (c) 2016 Rangle.io',
    type: 'MIT'
  },
  {
    name: 'autoprefixer',
    year: 'Copyright 2013 Andrey Sitnik <andrey@sitnik.ru>',
    type: 'MIT'
  },
  {
    name: 'axios',
    year: 'Copyright (c) 2014-present Matt Zabriskie',
    type: 'MIT'
  },
  {
    name: 'babel-core',
    year: 'Copyright (c) 2014-present Sebastian McKenzie and other contributors',
    type: 'MIT'
  },
  {
    name: 'babel-eslint',
    year: 'Copyright (c) 2014-2016 Sebastian McKenzie <sebmck@gmail.com>',
    type: 'MIT'
  },
  {
    name: 'babel-jest',
    year: 'Copyright (c) 2014-present, Facebook, Inc.',
    type: 'MIT'
  },
  {
    name: 'babel-loader',
    year: 'Copyright (c) 2014-2016 Luís Couto <hello@luiscouto.pt>',
    type: 'MIT'
  },
  {
    name: 'babel-preset-react-app',
    year: 'Copyright (c) 2013-present, Facebook, Inc.',
    type: 'MIT'
  },
  {
    name: 'canvg',
    year: 'Copyright (c) 2010-2011 Gabe Lerner (gabelerner@gmail.com) - http://code.google.com/p/canvg/',
    type: 'MIT'
  },
  {
    name: 'case-sensitive-paths-webpack-plugin',
    year: 'Copyright (c) 2018 Michael Pratt',
    type: 'MIT'
  },
  {
    name: 'chalk',
    year: 'Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)',
    type: 'MIT'
  },
  {
    name: 'chart.js',
    year: 'Copyright (c) 2018 Chart.js Contributors',
    type: 'MIT'
  },
  {
    name: 'chartjs-plugin-datalabels',
    year: 'Copyright (c) 2018 Chart.js Contributors',
    type: 'MIT'
  },
  {
    name: 'classnames',
    year: 'Copyright (c) 2018 Jed Watson',
    type: 'MIT'
  },
  {
    name: 'connect-history-api-fallback',
    year: 'Copyright (c) 2012 Ben Ripkens http://bripkens.de',
    type: 'MIT'
  },
  {
    name: 'css-loader',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'detect-port',
    year: 'Copyright (c) 2014 - present node-modules and other contributors',
    type: 'MIT'
  },
  {
    name: 'dom-to-image-chrome-fix-retina',
    year: `Copyright 2015 Anatolii Saienko 
                 https://github.com/tsayen
 
                 Copyright 2012 Paul Bakaus
                 http://paulbakaus.com/
             `,
    type: 'MIT'
  },
  {
    name: 'dotenv',
    year: 'Copyright (c) 2015, Scott Motte',
    type: 'BSD-3-Clause'
  },
  {
    name: 'draft-js',
    year: 'Copyright (c) Facebook, Inc. and its affiliates.',
    type: 'MIT'
  },
  {
    name: 'echarts',
    year: `Version 2.0, January 2004
                         http://www.apache.org/licenses/`,
    type: 'Apache-2.0'
  },
  {
    name: 'echarts-for-react',
    year: 'Copyright (c) hustcc',
    type: 'MIT'
  },
  {
    name: 'es6-promise',
    year: 'Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors',
    type: 'MIT'
  },
  {
    name: 'extract-text-webpack-plugin',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'file-loader',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'filesize',
    year: 'Copyright (c) 2019, Jason Mulligan',
    type: 'BSD-3-Clause'
  },
  {
    name: 'find-cache-dir',
    year: 'Copyright (c) James Talmage <james@talmage.io> (github.com/jamestalmage)',
    type: 'MIT'
  },
  {
    name: 'fs-extra',
    year: 'Copyright (c) 2011-2017 JP Richardson',
    type: 'MIT'
  },
  {
    name: 'gzip-size',
    year: 'Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)',
    type: 'MIT'
  },
  {
    name: 'html-webpack-plugin',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'html2canvas',
    year: 'Copyright (c) 2012 Niklas von Hertzen',
    type: 'MIT'
  },
  {
    name: 'http-proxy-middleware',
    year: 'Copyright (c) 2015 Steven Chim',
    type: 'MIT'
  },
  {
    name: 'http-status-codes',
    year: '',
    type: 'MIT'
  },
  {
    name: 'immutable',
    year: 'Copyright (c) 2014-present, Facebook, Inc.',
    type: 'MIT'
  },
  {
    name: 'intl',
    year: 'Copyright (c) 2013 Andy Earnshaw',
    type: 'MIT'
  },
  {
    name: 'intl-locales-supported',
    year: 'Copyright (c) 2015, Yahoo Inc.  All rights reserved.',
    type: 'BSD-3-Clause'
  },
  {
    name: 'json-loader',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'jwt-decode',
    year: 'Copyright (c) 2015 Auth0, Inc. <support@auth0.com> (http://auth0.com)',
    type: 'MIT'
  },
  {
    name: 'l',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'lodash',
    year: 'Copyright JS Foundation and other contributors <https://js.foundation/>',
    type: 'MIT'
  },
  {
    name: 'lodash.assign',
    year: 'Copyright JS Foundation and other contributors <https://js.foundation/>',
    type: 'MIT'
  },
  {
    name: 'material-ui-pickers',
    year: 'Copyright (c) 2017 Dmitriy Kovalenko',
    type: 'MIT'
  },
  {
    name: 'mixpanel-browser',
    year: 'Copyright 2015 Mixpanel, Inc.',
    type: 'MIT'
  },
  {
    name: 'mobile-detect',
    year: 'Copyright (c) 2013 Heinrich Goebl',
    type: 'MIT'
  },
  {
    name: 'moment-timezone',
    year: 'Copyright (c) JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'node-sass',
    year: 'Copyright (c) 2013-2016 Andrew Nesbitt',
    type: 'MIT'
  },
  {
    name: 'object-assign',
    year: 'Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)',
    type: 'MIT'
  },
  {
    name: 'path-exists',
    year: 'Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)',
    type: 'MIT'
  },
  {
    name: 'postcss-loader',
    year: 'Copyright 2017 Andrey Sitnik <andrey@sitnik.ru>',
    type: 'MIT'
  },
  {
    name: 'prettier',
    year: 'Copyright © James Long and contributors',
    type: 'MIT'
  },
  {
    name: 'promise',
    year: 'Copyright (c) 2014 Forbes Lindesay',
    type: 'MIT'
  },
  {
    name: 'prop-types',
    year: 'Copyright (c) 2013-present, Facebook, Inc.',
    type: 'MIT'
  },
  {
    name: 'rc-progress',
    year: 'Copyright (c) 2014-present yiminghe',
    type: 'MIT'
  },
  {
    name: 'rc-slider',
    year: 'Copyright (c) 2015-present Alipay.com, https://www.alipay.com/',
    type: 'MIT'
  },
  {
    name: 'react',
    year: 'Copyright (c) Facebook, Inc. and its affiliates.',
    type: 'MIT'
  },
  {
    name: 'react-addons-shallow-compare',
    year: '',
    type: 'MIT'
  },
  {
    name: 'react-chartjs-2',
    year: 'Copyright (c) 2017 Jeremy Ayerst',
    type: 'MIT'
  },
  {
    name: 'react-copy-to-clipboard',
    year: 'Copyright (c) 2016 Nik Butenko',
    type: 'MIT'
  },
  {
    name: 'react-csv',
    year: 'Copyright (c) 2019 react-csv',
    type: 'MIT'
  },
  {
    name: 'react-dev-utils',
    year: '',
    type: 'MIT'
  },
  {
    name: 'react-dom',
    year: 'Copyright (c) Facebook, Inc. and its affiliates.',
    type: 'MIT'
  },
  {
    name: 'react-dropzone',
    year: 'Copyright (c) 2018 Param Aggarwal',
    type: 'MIT'
  },
  {
    name: 'react-file-reader',
    year: 'Copyright (c) 2017 Grillwork',
    type: 'MIT'
  },
  {
    name: 'react-ga',
    year: '',
    type: 'Apache-2.0'
  },
  {
    name: 'react-grid-system',
    year: 'Copyright (c) 2016, JSxMachina',
    type: 'ISC'
  },
  {
    name: 'react-immutable-proptypes',
    year: 'Copyright (c) 2015 James Burnett',
    type: 'MIT'
  },
  {
    name: 'react-intl',
    year: 'Copyright 2014 Yahoo Inc. All rights reserved.',
    type: 'BSD-3-Clause'
  },
  {
    name: 'react-modal',
    year: 'Copyright (c) 2017 Ryan Florence',
    type: 'MIT'
  },
  {
    name: 'react-number-format',
    year: 'Copyright (c) <2016-2019> <Sudhanshu Yadav>',
    type: 'MIT'
  },
  {
    name: 'react-phone-number-input',
    year: 'Copyright (c) 2016 @catamphetamine <purecatamphetamine@gmail.com>',
    type: 'MIT'
  },
  {
    name: 'react-redux',
    year: 'Copyright (c) 2015-present Dan Abramov',
    type: 'MIT'
  },
  {
    name: 'react-responsive',
    year: 'Copyright (c) 2014 Fractal <contact@wearefractal.com>',
    type: 'MIT'
  },
  {
    name: 'react-router',
    year: 'Copyright (c) React Training 2016-2018',
    type: 'MIT'
  },
  {
    name: 'react-router-dom',
    year: 'Copyright (c) React Training 2016-2018',
    type: 'MIT'
  },
  {
    name: 'react-scroll',
    year: 'Copyright (c) 2015 Joachim Karlsson (fisshy)',
    type: 'MIT'
  },
  {
    name: 'react-search-input',
    year: 'Copyright (c) MIT',
    type: 'MIT'
  },
  {
    name: 'react-share',
    year: 'Copyright (c) 2015 Klaus Nygård',
    type: 'MIT'
  },
  {
    name: 'react-slick',
    year: 'Copyright (c) 2014 Kiran Abburi',
    type: 'MIT'
  },
  {
    name: 'react-sortable-hoc',
    year: 'Copyright (c) 2016, Claudéric Demers',
    type: 'MIT'
  },
  {
    name: 'react-stickynode',
    year: 'Copyright (c) 2015, Yahoo Inc. All rights reserved.',
    type: 'BSD-3-Clause'
  },
  {
    name: 'react-swipeable',
    year: 'Copyright (C) 2014-present Dogfessional',
    type: 'MIT'
  },
  {
    name: 'react-tag-input',
    year: 'Copyright (c) 2015 Prakhar Srivastav',
    type: 'MIT'
  },
  {
    name: 'react-toastify',
    year: 'Copyright (c) 2017 Fadi Khadra',
    type: 'MIT'
  },
  {
    name: 'react-toggle-button',
    year: 'Copyright (c) 2016 Gavin Owens',
    type: 'MIT'
  },
  {
    name: 'react-token-autocomplete',
    year: '',
    type: 'ISC'
  },
  {
    name: 'react-tooltip',
    year: 'Copyright (c) 2015 Wang Zixiao',
    type: 'MIT'
  },
  {
    name: 'react-transition-group',
    year: `Copyright (c) 2018, React Community
                Forked from React (https://github.com/facebook/react) Copyright 2013-present, Facebook, Inc.
                All rights reserved.`,
    type: 'BSD-3-Clause'
  },
  {
    name: 'recursive-readdir',
    year: 'Copyright (c)',
    type: 'MIT'
  },
  {
    name: 'redux',
    year: 'Copyright (c) 2015-present Dan Abramov',
    type: 'MIT'
  },
  {
    name: 'redux-beacon',
    year: 'Copyright (c) 2016 Rangle.io',
    type: 'MIT'
  },
  {
    name: 'redux-observable',
    year: 'Copyright (c) 2016-2018 Ben Lesh, Jay Phelps, and redux-observable contributors.',
    type: 'MIT'
  },
  {
    name: 'redux-promise-middleware',
    year: 'Copyright (c) 2015 Patrick Burtchaell',
    type: 'MIT'
  },
  {
    name: 'redux-thunk',
    year: 'Copyright (c) 2015-present Dan Abramov',
    type: 'MIT'
  },
  {
    name: 'reselect',
    year: 'Copyright (c) 2015-2018 Reselect Contributors',
    type: 'MIT'
  },
  {
    name: 'rimraf',
    year: 'Copyright (c) Isaac Z. Schlueter and Contributors',
    type: 'ISC'
  },
  {
    name: 'rxjs',
    year: 'Copyright (c) Version 2.0, January 2004',
    type: 'Apache-2.0'
  },
  {
    name: 'sass-loader',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'screenfull',
    year: 'Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)',
    type: 'MIT'
  },
  {
    name: 'style-loader',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'universal-cookie',
    year: 'Copyright (c) 2015 Benoit Tremblay',
    type: 'MIT'
  },
  {
    name: 'url-loader',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'webpack',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'webpack-dev-server',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'webpack-manifest-plugin',
    year: 'Copyright (c) Dane Thurber <dane.thurber@gmail.com>',
    type: 'MIT'
  },
  {
    name: 'whatwg-fetch',
    year: 'Copyright (c) 2014-2016 GitHub, Inc.',
    type: 'MIT'
  },
  {
    name: 'compressorjs',
    year: 'Copyright 2018-present Chen Fengyuan',
    type: 'MIT'
  },
  {
    name: 'qr-code-with-logo',
    year: 'Copyright 2018-present Chen Fengyuan',
    type: 'MIT'
  },
  {
    name: 'qrcode',
    year: 'Copyright (c) 2012 Ryan Day',
    type: 'MIT'
  },
  {
    name: 'react-swipeable-views',
    year: 'Copyright (c) 2015 Olivier Tassinari',
    type: 'MIT'
  },
  {
    name: 'workbox-webpack-plugin',
    year: 'Copyright 2018 Google LLC',
    type: 'MIT'
  },
  {
    name: 'ts-pnp',
    year: 'Copyright © 2016 Maël Nison',
    type: 'MIT'
  },
  {
    name: 'terser-webpack-plugin',
    year: 'Copyright JS Foundation and other contributors',
    type: 'MIT'
  },
  {
    name: 'resolve-url-loader',
    year: '',
    type: 'MIT'
  },
  {
    name: 'resolve',
    year: 'Copyright (c) 2012 James Halliday',
    type: 'MIT'
  },
  {
    name: 'redux-thunk',
    year: 'Copyright (c) 2015-present Dan Abramov',
    type: 'MIT'
  },
  {
    name: 'react-joyride',
    type: 'MIT',
    year: 'Copyright (c) 2015, Gil Barbara'
  },
  {
    name: 'react-gtm-module',
    type: 'MIT',
    year: 'Copyright (c) 2016 HolidayCheck'
  },
  {
    name: 'react-dice-complete',
    type: 'ISC',
    year: 'Copyright (c) 2019 Adam Tyler'
  },
  {
    name: 'qs',
    type: 'BSD-3-Clause',
    year: 'Copyright (c) 2014, Nathan LaFreniere '
  },
  {
    name: 'postcss-safe-parser',
    type: 'MIT',
    year: 'opyright 2013 Andrey Sitnik <andrey@sitnik.ru>'
  },
  {
    name: 'postcss-safe-parser',
    type: 'MIT',
    year: 'opyright 2013 Andrey Sitnik <andrey@sitnik.ru>'
  },
  {
    name: 'postcss-flexbugs-fixes',
    type: 'MIT',
    year: 'Copyright 2015 Luis Rudge <luis@luisrudge.net>'
  },
  {
    name: 'pnp-webpack-plugin',
    type: 'MIT',
    year: 'Copyright © 2016 Maël Nison'
  },
  {
    name: 'pnp-webpack-plugin',
    type: 'MIT',
    year: 'Copyright © 2016 Maël Nison'
  },
  {
    name: 'optimize-css-assets-webpack-plugin',
    type: 'MIT',
    year: 'Copyright (c) 2016 Nuno Rodrigues'
  },
  {
    name: 'optimize-css-assets-webpack-plugin',
    type: 'MIT',
    year: 'Copyright (c) 2016 Nuno Rodrigues'
  },
  {
    name: 'Unlocked Lottie Animation',
    type: 'Creative Commons License 4.0',
    year: 'Copyright (c) 2019 Debashish Nabajja'
  },
  {
    name: 'animated-scroll-to',
    type: 'MIT',
    year: 'Copyright 2016-present Stanko Tadić'
  },
  {
    name: 'whiteboard',
    type: 'MIT',
    year: 'Copyright (c) 2018 Cracker'
  },
  {
    name: 'react-player',
    type: 'MIT',
    year: 'Copyright © Pete Cook'
  },
  {
    name: 'vcard-creator',
    type: 'MIT',
    year: 'Copyright (c) 2017 João Carmo'
  },
  {
    name: 'react-sticky-el',
    type: 'MIT',
    year: 'Copyright (c) 2016 Mikhail Bogdanov'
  },
  {
    name: 'swiper',
    type: 'MIT',
    year: 'Copyright (c) 2019 Vladimir Kharlampidi\n'
  },
  {
    name: 'hoist-non-react-statics',
    type: 'BSD',
    year: 'Copyright (c) 2015, Yahoo! Inc.'
  },
  {
    name: 'shave',
    type: 'MIT',
    year: 'Copyright (c) 2016 Jeff Wainwright'
  },
  {
    name: 'react-clear-cache',
    type: 'MIT',
    year: 'Copyright (c) 2019 Noah John Ucab'
  },
  {
    name: 'file-saver',
    type: 'MIT',
    year: 'Copyright © 2016 Eli Grey'
  },
  {
    name: 'lottie-web',
    type: 'MIT',
    year: 'Copyright (c) 2015 Bodymovin'
  },
  {
    name: 'react-flip-move',
    type: 'MIT',
    year: 'Copyright (c) 2016-present Joshua Comeau'
  },
  {
    name: 'csvtojson',
    type: 'MIT',
    year: 'Copyright (C) 2013 Keyang Xiang'
  },
  {
    name: 'proj4js',
    type: 'MIT',
    year:
      'Copyright (c) 2014, Mike Adair, Richard Greenwood, Didier Richard, Stephen Irons, Olivier Terral and Calvin Metcalf'
  },
  {
    name: 'threads',
    type: 'MIT',
    year: 'Copyright (c) 2019 Andy Wermke'
  },
  {
    name: 'emoji-mart',
    type: 'BSD-3-Clause',
    year: 'Copyright (c) 2016, Missive'
  },
  {
    name: 'draft-js-custom-styles',
    type: 'MIT',
    year: 'Copyright (c) 2018 Luis'
  },
  {
    name: 'draft-js-focus-plugin',
    type: 'MIT',
    year: 'Copyright (c) 2016 Nikolaus Graf'
  },
  {
    name: 'draft-js-alignment-plugin',
    type: 'MIT',
    year: 'Copyright (c) 2016 Nikolaus Graf'
  },
  {
    name: 'draft-js-image-plugin',
    type: 'MIT',
    year: 'Copyright (c) 2016 Nikolaus Graf'
  },
  {
    name: 'draft-js-plugins-editor',
    type: 'MIT',
    year: 'Copyright (c) 2016 Nikolaus Graf'
  },
  {
    name: 'draft-js-static-toolbar-plugin',
    type: 'MIT',
    year: 'Copyright (c) 2016 Nikolaus Graf'
  },
  {
    name: 'react-device-detect',
    type: 'MIT',
    year: 'Copyright (c) 2017 duskload'
  },
  {
    name: '@daily-co/daily-js',
    type: 'BSD- 2-Clause',
    year: 'Copyright (c) 2019, daily-co'
  },
  {
    name: 'react-cookie',
    type: 'MIT',
    year: 'Copyright (c) 2015 Benoit Tremblay'
  },
  {
    name: '@date-io/moment',
    type: 'MIT',
    year: 'Copyright (c) 2017 Dmitriy Kovalenko\n'
  },
  {
    name: 'money',
    type: 'MIT',
    year: 'Copyright (c) 2014 Open Exchange Rates'
  }
];

export default licenses;
